// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6a0e4739","793":"e1e0c419"}[chunkId] + ".chunk.js";
};